// Firebase Web SDK initialisation for Ace Asia Productions.
//
// NOTE: these values are PUBLIC Firebase identifiers (not secrets) — they are
// safe to ship in client code. Access is controlled by Firestore/Storage
// security rules, not by hiding this config. Env vars override the defaults so
// the same build can target another project if ever needed.

import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCONnwzHrnYaBRYraJnO7c8IUmyv86RGp0",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "ace-asia-productions.firebaseapp.com",
  projectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID || "ace-asia-productions",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "ace-asia-productions.firebasestorage.app",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "945705772534",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:945705772534:web:fbb258cedb8b20656313d7",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Local development against `firebase emulators:start`. Off unless asked for,
// so a production build can never be pointed at a local emulator by accident.
// Enable with REACT_APP_USE_EMULATORS=1 when running the dev server.
if (process.env.REACT_APP_USE_EMULATORS === "1") {
  const host = process.env.REACT_APP_EMULATOR_HOST || "127.0.0.1";
  connectFirestoreEmulator(db, host, 8080);
  connectAuthEmulator(getAuth(app), `http://${host}:9099`, { disableWarnings: true });
  // eslint-disable-next-line no-console
  console.info(`[firebase] using emulators at ${host}`);
}
